module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_1"
  }, [_c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, _vm._l((_vm.cardList), function(item, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "span": 6
      }
    }, [_c('el-card', [_c('div', {
      staticClass: "card",
      on: {
        "mouseover": function($event) {
          _vm.update(item)
        },
        "mouseout": function($event) {
          _vm.update(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.desc))])])])])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4fea5d70"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/solution/tab_1.vue
// module id = 785
// module chunks = 1